import { NormalButton } from 'components/buttons/ButtonStyle';
import React, { useState, useEffect, FC } from 'react';
import styled from 'styled-components';
import EmptyImage from './EmptyImage';

interface ImageSliderProps {
  images: any;
  alt?: string;
  className?: string;
}

const ImageSlider: FC<ImageSliderProps> = ({ images, alt = '', className }) => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    setIdx(0);
  }, [images]);

  if (!images || images.length === 0) {
    return (
      <SliderWrapper className="no-image">
        <EmptyImage height={300} />
      </SliderWrapper>
    );
  }

  const prev = () => setIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setIdx((i) => (i + 1) % images.length);

  return (
    <SliderWrapper className={className}>
      <SlideContainer>
        <MainImage src={images[idx]?.img || ''} alt={alt} />
      </SlideContainer>
      {images.length > 1 && (
        <ButtonArea>
          <NormalButton className="noIconBtn" onClick={prev}>
            prev
          </NormalButton>
          <span>{`${idx + 1}/${images.length}`}</span>
          <NormalButton className="noIconBtn" onClick={next}>
            next
          </NormalButton>
        </ButtonArea>
      )}
      {images.length > 0 && <div className="date">등록일: {images[idx]?.date || ''}</div>}
    </SliderWrapper>
  );
};

export default ImageSlider;

export const SliderWrapper = styled.div`
  width: 100%;
  .no-image {
    height: 200;
    display: 'flex';
    align-items: 'center';
    justify-content: 'center';
    background: '#f3f4f6';
  }
  & > .date {
    position: absolute;
    bottom: 25px;
    right: 40px;
  }
`;

export const SlideContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MainImage = styled.img`
  width: auto;
  height: auto;
  min-height: 100%;
  max-height: 60vh;
  border-radius: 6px;
  object-fit: contain;
`;

export const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 8px;
  span {
    padding: 5px 8px;
    font-family: bold;
  }
`;
